import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PUT_AWAY_STATUS } from 'domains/merchant-inventory-batch/constants/merchant-inventory-batch-item-constants'

const propTypes = {
  putAwayStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Inventory Batch `put_away_status`.
 * It maps `put_away_status` to certain style and pass to `StatusBadge`.
 * @param {string} put_away_status Merchant Inbound Inventory Batch Item.
 */
const MerchantInventoryBatchItemPutAwayStatusBadge = ({ putAwayStatus }) => {

  const colorMap = {
    [PUT_AWAY_STATUS.PENDING]   : 'warning',
    [PUT_AWAY_STATUS.PARTIAL]   : 'primary',
    [PUT_AWAY_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[putAwayStatus]

  return <StatusBadge color={ color } label={ putAwayStatus } />
}

MerchantInventoryBatchItemPutAwayStatusBadge.propTypes = propTypes

export default MerchantInventoryBatchItemPutAwayStatusBadge
